/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import LinksList from '@salesforce/retail-react-app/app/theme/components/project/links-list'

LinksList.baseStyle = {
    ...LinksList.baseStyle,
    container: {
        width: 'fit-content'
    },
    headingLink: {
        display: 'inline-flex',
        _hover: {
            textDecoration: 'none !important'
        }
    },
    heading: {
        color: 'black',
        fontWeight: '400',
        fontSize: '26px',
        fontFamily: 'caslon'
    },
    list: {
        link: {
            fontSize: '14px',
            fontFamily: 'body',
            fontWeight: '300',
            _hover: {
                color: 'teal.400',
                textDecoration: 'none'
            },
            transition: 'color 0.3s ease'
        }
    }
}
export default LinksList
